import React, { useState } from "react";
import { Button, TouchableOpacity, View } from "react-native";

import { Ionicons } from "@expo/vector-icons";
import Input from "../../components/Forms/Input";
import tw from "../../styles/tailwind";


export default function PasswordInput({ name, control, placeholder, rules, style={} }) {
  const [showPassword, setShowPassword] = useState(false);
  const [iconName, setIconName] = useState("eye-outline");

  const toggleVisibility = () => {
    setIconName(showPassword ? "eye-outline" : "eye-off-outline")
    setShowPassword(!showPassword)
  }

  return (
    <View style={tw``}>
      <Input
        name={name}
        control={control}
        placeholder={placeholder}
        autoComplete={'off'}
        autoCapitalize={"none"}
        autoCorrect={false}
        rules={rules}
        style={{ container: tw``, subcontainer: tw`bg-white`, input: tw`h-12 rounded-full text-gray-800`, ...style }}
        secureTextEntry={!showPassword}
      />

      <TouchableOpacity style={tw`absolute right-4 top-3`} onPress={toggleVisibility}>
        <Ionicons name={iconName} size={24} color={tw.color('gray-500')} />
      </TouchableOpacity>
    </View>
  )
}